/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ExternalCatalogPatch } from './ExternalCatalogPatch';

export type AssetPatchDto = {
    customMetadataEntriesOperation?: AssetPatchDto.customMetadataEntriesOperation;
    customMetadataEntryIds?: Array<string>;
    description?: string;
    externalCatalogPatch?: ExternalCatalogPatch;
    ownerIds?: Array<string>;
    tagIds?: Array<string>;
    termIds?: Array<string>;
};

export namespace AssetPatchDto {

    export enum customMetadataEntriesOperation {
        ADD = 'ADD',
        REPLACE = 'REPLACE',
    }


}
